import Planos from "@/Pages/Planos/index.vue";
import PlanosInfantil from "@/Pages/PlanosInfantil/index.vue";
import PlanosVisualizar from "@/Pages/Planos/visualizar.vue";
import PlanosInfantilVisualizar from "@/Pages/PlanosInfantil/visualizar.vue";

/* -Anual-*/
import planosAnuais from "@/Pages/PlanosAnuais/index.vue";
import PlanosAnuaisInfantil from "@/Pages/PlanosAnuaisInfantil/index.vue";
import PlanosAnuaisVisualizar from "@/Pages/PlanosAnuais/visualizar.vue";
// import PlanosAnuaisInfantilVisualizar from "@/Pages/PlanosAnuaisInfantil/visualizar.vue";

export default [
  {
    path: "/gestoes-de-aulas/planos",
    name: "gestoesDeAulas.planos",
    component: Planos,
  },
  {
    path: "/gestoes-de-aulas/planos/:id/visualizar",
    name: "gestoesDeAulas.planosVisualizar",
    component: PlanosVisualizar,
  },
  // Infantil
  {
    path: "/gestoes-de-aulas/planos/infantil",
    name: "gestoesDeAulas.planosInfantil",
    component: PlanosInfantil,
  },
  {
    path: "/gestoes-de-aulas/planos/infantil/:id/visualizar",
    name: "gestoesDeAulas.planosInfantilVisualizar",
    component: PlanosInfantilVisualizar,
  },

  /* ------Anual-------*/

  {
    path: "/gestoes-de-aulas/planosAnuais",
    name: "gestoesDeAulas.planosAnuais",
    component: planosAnuais,
  },
  {
    path: "/gestoes-de-aulas/planosAnuais/:id/visualizar",
    name: "gestoesDeAulas.planosAnuaisVisualizar",
    component: PlanosAnuaisVisualizar,
  },
  // Infantil
  {
    path: "/gestoes-de-aulas/planosAnuais/infantil",
    name: "gestoesDeAulas.planosAnuaisInfantil",
    component: PlanosAnuaisInfantil,
  },
  // {
  //   path: "/gestoes-de-aulas/planos/infantil/:id/visualizar",
  //   name: "gestoesDeAulas.planosAnuaisInfantilVisualizar",
  //   component: PlanosAnuaisInfantilVisualizar,
  // },
];
